import {
  GET_INTERNALSAMPLE_FAIL,
  GET_INTERNALSAMPLE_SUCCESS,
  GET_INTERNALSAMPLES_FAIL,
  GET_INTERNALSAMPLES_SUCCESS,
  ADD_INTERNALSAMPLE_SUCCESS,
  ADD_INTERNALSAMPLE_FAIL,
  UPDATE_INTERNALSAMPLE_SUCCESS,
  UPDATE_INTERNALSAMPLE_FAIL,
  DELETE_INTERNALSAMPLE_SUCCESS,
  DELETE_INTERNALSAMPLE_FAIL,  
  SET_STATE_INTERNALSAMPLE
} from "./actionTypes";

const INIT_STATE = {
  internalSamples: [],
  internalSample: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const internalSamples = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_INTERNALSAMPLES_SUCCESS:
      return {
        ...state,
        internalSamples: action.payload.internalSamples,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_INTERNALSAMPLE:
      return { ...state, loading: action.payload }

    case GET_INTERNALSAMPLES_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_INTERNALSAMPLE_SUCCESS:
      return {
        ...state,
        internalSamples: [...state.internalSamples, action.payload],
      };

    case ADD_INTERNALSAMPLE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_INTERNALSAMPLE_SUCCESS:
      return {
        ...state,
        internalSamples: state.internalSamples.map(internalSample =>
          internalSample.id.toString() === action.payload.id.toString()
            ? { ...action.payload, internalSample }
            : internalSample
        ),
      };

    case UPDATE_INTERNALSAMPLE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_INTERNALSAMPLE_SUCCESS:
      return {
        ...state,
        internalSamples: state.internalSamples.filter(
          internalSample => internalSample.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_INTERNALSAMPLE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_INTERNALSAMPLE_SUCCESS:
      return {
        ...state,
        internalSample: action.payload,
      };

    case GET_INTERNALSAMPLE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default internalSamples;
